import { useRef } from "react";

export function useWhatChanged(
	name: string,
	props?: Record<string, unknown>,
	state?: Record<string, unknown>,
	store?: Record<string, unknown>
) {
	const count = useRef(0);
	count.current += 1;

	const propsRef = useRef({ ...props });
	const stateRef = useRef({ ...state });
	const storeRef = useRef({ ...store });

	console.log(`[${name}] Render #${count.current}`);
	if (props) {
		compare("props", props, propsRef.current);
		propsRef.current = { ...props };
	}

	if (state) {
		compare("state", state, stateRef.current);
		stateRef.current = { ...state };
	}

	if (store) {
		compare("store", store, storeRef.current);
		storeRef.current = { ...store };
	}
}

function compare(
	props: string,
	deps: Record<string, unknown>,
	prev: Record<string, unknown>
) {
	const changes = Object.entries(deps).filter(
		([key, val]) => prev[key] !== val
	);

	if (changes.length) {
		changes.forEach(([key, val]) => {
			console.log(`  ${props}.${key}:`, prev[key], "→", val);
		});
	}
}
